import { LocationsService, RackEndCustomerMapService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { FGStockService, ForkLiftJobService } from '@gtpl/shared-services/warehouse-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ForkLiftItems } from '../fork-lift-items/fork-lift-items.entity';
import { Notifications } from '../notifications/notifications.entity';
import { NotificationsService } from '../notifications/notifications.service';
import { StockRepository } from '../stock/repositories/stock-repository';
import { ForkLiftJobAdapter } from './dto/fork-lift-job.adapter';
import { ForkLiftJobsController } from './fork-lift-jobs.controller';
import { ForkLiftJobs } from './fork-lift-jobs.entity';
import { ForkLiftJobsService } from './fork-lift-jobs.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ForkLiftJobs,ForkLiftItems,Notifications])
  ],
  controllers: [ForkLiftJobsController],
  providers: [ForkLiftJobsService,ForkLiftJobAdapter,ApplicationExceptionHandler,FGStockService,RackEndCustomerMapService,LocationsService,SaleOrderService,NotificationsService,ForkLiftJobService,StockRepository]
})
export class ForkLiftJobsModule {}
